/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fetchFinancial } from '@dev-togetherprice/api.services';
import useSWR from 'swr';
export const useCard = () => useSWR('/findCard', fetchFinancial, {
    revalidateOnMount: true,
    suspense: true,
});
export const useWalletBalance = (options = {}) => useSWR('/wallet/getWalletBalance', fetchFinancial, Object.assign({ suspense: true, revalidateOnMount: true }, options));
export const useStripeInfo = () => useSWR('/getStripeInfo', fetchFinancial, {
    revalidateOnMount: true,
    suspense: true,
});
